// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* In your CSS file */
.custom-patient-table .ant-table-thead>tr>th {
  background-color: #298E9F;
  /* light blue header */
  color: #fff;
  font-weight: bold;
}

.custom-patient-table .ant-table-tbody>tr:hover {
  background-color: #e6f7ff;
}

/* Customize the Select border color */
.custom-select .ant-select-selector {
  border-color: #298d9fbe !important;
  /* Your desired color */
  border-width: 2px;
  border-radius: 6px;
}

/* Optional: focus style */
.custom-select.ant-select-focused .ant-select-selector {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  /* light blue focus ring */
  border-color: #298d9f73 !important;
}

.patients-wrapper {
  padding: 16px;
}

.filter-label {
  font-weight: 500;
}
.patients-wrapper {
  padding: 16px;
}

.filters-wrapper {
  flex-direction: column;
  
  margin-top: 12px;
}

@media (max-width: 768px) {
  .filters-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Screens/PatientsList/patientList.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;;EAEtB,gBAAgB;AAClB;;AAEA;EACE;IAQE,sBAAsB;IACtB,uBAAuB;EANzB;AACF","sourcesContent":["/* In your CSS file */\n.custom-patient-table .ant-table-thead>tr>th {\n  background-color: #298E9F;\n  /* light blue header */\n  color: #fff;\n  font-weight: bold;\n}\n\n.custom-patient-table .ant-table-tbody>tr:hover {\n  background-color: #e6f7ff;\n}\n\n/* Customize the Select border color */\n.custom-select .ant-select-selector {\n  border-color: #298d9fbe !important;\n  /* Your desired color */\n  border-width: 2px;\n  border-radius: 6px;\n}\n\n/* Optional: focus style */\n.custom-select.ant-select-focused .ant-select-selector {\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n  /* light blue focus ring */\n  border-color: #298d9f73 !important;\n}\n\n.patients-wrapper {\n  padding: 16px;\n}\n\n.filter-label {\n  font-weight: 500;\n}\n.patients-wrapper {\n  padding: 16px;\n}\n\n.filters-wrapper {\n  flex-direction: column;\n  \n  margin-top: 12px;\n}\n\n@media (max-width: 768px) {\n  .filters-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 768px) {\n  .filters-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
